<template>
  <div>
    <v-card class="pa-5 mb-5 elevation-hb">
      <v-row align-content="space-around">
        <v-col>
          <h3>Produtos do Seller - {{ $route.params.id }}</h3>
        </v-col>
        <v-col cols="3">
          <TheSearchInput v-model="search" />
        </v-col>
      </v-row>
      <v-divider class="my-3"></v-divider>
      <div class="text-right">
        <v-btn
          depressed
          color="primary"
          small
          :loading="loading"
          class="text-center mr-1"
          :dark="selected.length > 0"
          :disabled="selected.length === 0"
          @click="editPriceMargin(null, true)"
        >
          <v-icon color="white" small class="mr-1">mdi-margin</v-icon>Alterar Preços em Massa
          <span v-if="selected.length > 0">({{ selected.length }})</span>
        </v-btn>
        <v-btn color="primary" small class="ml-1" depressed dark :loading="loading" @click="importInput()">
          <v-icon class="mr-1" small>mdi-database-import</v-icon>Importação em massa
        </v-btn>
        <input style="display: none" type="file" ref="arquivo" id="fileInput" @change="sendFile()" />

        <v-btn color="primary" small class="ml-1" depressed dark :loading="loading" :href="download" target="_blank">
          <v-icon class="mr-1" small>mdi-download</v-icon>Download modelo CSV
        </v-btn>

        <v-btn color="primary" small class="ml-1" depressed dark :loading="loading" @click="openAddProductDialog()">
          <v-icon class="mr-1" small>mdi-plus</v-icon>Adicionar Produto
        </v-btn>

        <v-btn color="primary" small class="ml-1" depressed dark :loading="loading" @click="downloadCSV()">
          <v-icon class="mr-1" small>mdi-plus</v-icon>Download CSV Estoque
        </v-btn>
      </div>
      <v-divider class="my-3"></v-divider>

      <v-progress-linear v-if="loading" :value="(quantity.actual * 100) / quantity.totaç"></v-progress-linear>

      <v-data-table :headers="headers" :items="products" :loading="loading" :search="search" dense item-key="skuId" show-select v-model="selected">
        <template v-slot:[`item.sellerProductName`]="{ item }">
          <div class="py-3">
            <h3>{{ item.sellerProductName }}</h3>
            <div class="caption">
              <b>Sku:</b> {{ item.sellerProductSku }}
              <span v-if="item.sellerProductCategory"> - <b>Categoria</b>: {{ item.sellerProductCategory }}</span>
            </div>
            <div class="caption" v-if="item.sellerProductEan">
              <b>Ean:</b> {{ item.sellerProductEan }}
              <TheToolTip label="Buscar SkuId pelo Ean" v-if="item.skuId === null && item.sellerProductEan">
                <v-icon small label @click="searchSkuIdByEan(item)">
                  mdi-magnify
                </v-icon>
              </TheToolTip>
            </div>
          </div>
        </template>

        <template v-slot:[`item.sellerProductSku`]="{}"> </template>
        <template v-slot:[`item.sellerProductCategory`]="{}"> </template>
        <template v-slot:[`item.sellerProductEan`]="{}"> </template>

        <template v-slot:[`item.skuIdBound`]="{ item }">
          <v-chip v-if="item.skuId > 0" color="green" text-color="white" label>
            Vinculado
          </v-chip>
          <v-chip v-if="item.skuId == null" label>Aguardando</v-chip>
        </template>

        <template v-slot:[`item.bound`]="{ item }">
          {{ item.skuId }}
        </template>

        <template v-slot:[`item.stockAmount`]="{ item }">
          <v-edit-dialog :return-value.sync="item.name" @save="save(item)" @cancel="cancel" @open="open">
            {{ item.stockAmount }}
            <template v-slot:input>
              <v-text-field v-model="item.stockAmount" label="Informe o estoque" single-line :disabled="!item.skuId"></v-text-field>
            </template>
          </v-edit-dialog>
        </template>

        <template v-slot:[`item.stockStatus`]="{ item }">
          <v-avatar :color="stockStatus(item)" size="18"></v-avatar>
        </template>

        <template v-slot:[`item.productPrice`]="{ item }">
          <p v-if="item.productPrice">
            {{ item.productPrice | formatFullMoney }}
          </p>
        </template>
        <template v-slot:[`item.sellerPrice`]="{ item }">
          <p v-if="item.sellerPrice">
            {{ item.sellerPrice | formatFullMoney }}
          </p>
        </template>

        <template v-slot:[`item.stockReserve`]="{ item }">
          {{ item.stockReserve }}
          <v-icon x-small @mouseenter="loadOrders(item)" @click="openDetails(item)">
            mdi-magnify
          </v-icon>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <TheToolTip label="Definir desconto" v-if="item.minPriceRange || item.maxPriceRange">
            <v-icon @click="editPriceMargin(item)">mdi-percent</v-icon>
          </TheToolTip>
          <TheToolTip label="Editar Produto">
            <v-icon @click="editProduct(item)">mdi-pen</v-icon>
          </TheToolTip>
          <TheToolTip label="Deletar Produto">
            <v-icon @click="deleteProduct(item)">mdi-delete</v-icon>
          </TheToolTip>
          <TheToolTip label="Histórico de Preços" class="mr-1" v-if="item.sellerPrice">
            <v-icon @click="getPriceHistoryDialog(item)">mdi-chart-areaspline</v-icon>
          </TheToolTip>
        </template>
      </v-data-table>
    </v-card>

    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>

    <TheDialog v-model="addProductDialog" width="600px" icon="mdi-archive" title="Adicionar Produto">
      <template>
        <v-form ref="form">
          <v-row>
            <v-col col="12">
              <v-text-field v-model="product.sellerProductName" outlined placeholder="Lavadora ágil" label="Nome" type="text" color="primary" required></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col col="6">
              <v-text-field v-model="product.sellerProductSku" outlined label="SKU" placeholder="Seu SKU" type="text" color="primary" required></v-text-field>
            </v-col>
            <v-col col="6">
              <v-text-field v-model="product.sellerProductEan" outlined label="EAN" placeholder="EAN do produto" type="text" color="primary"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col col="6">
              <v-text-field v-model="product.sellerProductBrand" outlined label="Marca" placeholder="WAP" type="text" color="primary"></v-text-field>
            </v-col>
            <v-col col="6">
              <v-text-field v-model="product.sellerProductCategory" outlined label="Categoria" placeholder="Lavadoras" type="text" color="primary"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col col="12">
              <v-textarea v-model="product.sellerProductDescription" outlined label="Descrição" placeholder="Um pouco sobre o produto" color="primary"></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </template>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-3" depressed dark @click="saveProduct">
          <v-icon>mdi-check</v-icon>
        </v-btn>
      </template>
    </TheDialog>

    <TheDialog v-model="detailsDialog" title="Detalhes das reservas" width="800px">
      <template>
        <v-data-table :headers="reservationHeaders" :items="orders" :loading="loading" dense>
          <template v-slot:[`item.orderSellerStatus`]="{ item }">
            {{ getStatusSeller(item.orderSellerStatus) }}
          </template>

          <template v-slot:[`item.action`]="{ item }">
            <TheToolTip label="Link Hubble">
              <v-icon small class="ml-2" @click="loadContent(item.orderId)">
                mdi-link
              </v-icon>
            </TheToolTip>

            <TheToolTip label="Link Vtex">
              <v-icon small class="ml-2" @click="loadVtex(item.orderId)">
                mdi-shield-link-variant-outline
              </v-icon>
            </TheToolTip>
          </template>
        </v-data-table>
      </template>
    </TheDialog>

    <TheDialog v-model="priceMarginDialog" title="Definição de margem de preço" width="800px" @closeFunction="closeMargin">
      <template>
        <p>
          Preço para: <b>{{ object.sellerProductName }}</b
          >.
        </p>
        <v-divider class="my-5"></v-divider>
        <h3>Definir Margem</h3>
        <v-row align="center" justify="center">
          <v-col cols="10">
            <v-slider v-model="slider" :max="max" :min="min" thumb-label="always" class="align-center my-10">
              <template v-slot:thumb-label="{ value }"> {{ value }}% </template>
              <template v-slot:prepend>
                <b>{{ min }}%</b>
              </template>
              <template v-slot:append>
                <b> {{ max }}%</b>
              </template>
            </v-slider>
          </v-col>
          <v-col cols="2">
            <v-text-field v-model="slider" outlined hide-details dense></v-text-field>
          </v-col>
        </v-row>

        <div v-if="!massUpdate">
          <v-divider class="my-5"></v-divider>
          <h3>Valores em Reais</h3>
          <v-simple-table>
            <tbody>
              <tr>
                <td width="20%">PDV WAP</td>
                <td>{{ object.productPrice | formatFullMoney }}</td>
              </tr>
              <tr>
                <td>Preço Seller</td>
                <td>
                  {{ appliedDiscount(object.productPrice) | formatFullMoney }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </template>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn :loading="loading" class="my-5" color="primary" @click="update(object)">salvar</v-btn>
      </template>
    </TheDialog>

    <TheDialog v-model="priceHistoryDialog" title="Histórico de Preços" width="800px">
      <template>
        <p>
          Histórico de Preços para: <b>{{ object.sellerProductName }}</b
          >.
        </p>
        <v-divider class="my-5"></v-divider>
        <div style="height: 400px">
          <IEcharts :option="virtualCart" :loading="loading" id="echart" ref="echart" />
        </div>
      </template>
    </TheDialog>
  </div>
</template>

<script>
import axios from 'axios'
import IEcharts from 'vue-echarts-v3/src/full.js'

import { mask } from 'vue-the-mask'
import { baseApiUrl, showError } from '@/global'
import { getStatusSeller } from '@/plugins/generic.js'

import TheSearchInput from '@/components/TheSearchInput'
import TheToolTip from '@/components/TheToolTip'
import TheDialog from '@/components/TheDialog'

export default {
  name: 'SellersProduct',
  components: {
    TheSearchInput,
    TheToolTip,
    TheDialog,
    IEcharts,
  },
  directives: { mask },
  computed: {
    download() {
      return `${this.$router.options.base}exemploProduto.csv`
    },
    virtualCart() {
      return this.chart
    },
  },
  data: () => ({
    snack: false,
    snackColor: '',
    snackText: '',
    addProductDialog: false,
    editProductFlag: false,
    detailsDialog: false,
    file: null,
    priceMarginDialog: false,
    min: 0.0,
    max: 0.0,
    slider: 0.0,
    object: {},
    headers: [
      { text: 'Vtex', value: 'skuIdBound', width: '7%' },
      // { text: 'Status', value: 'stockStatus', align: 'center', width: '5%' },
      { text: 'Sku Wap', value: 'skuId', width: '5%' },
      { text: 'Nome', value: 'sellerProductName' },
      { text: '', value: 'sellerProductSku', width: '0' },
      { text: '', value: 'sellerProductCategory', width: '0%' },
      { text: '', value: 'sellerProductEan', width: '0%' },
      {
        text: 'Estoque Disponível',
        value: 'stockAmount',
        width: '8%',
        align: 'center',
      },
      {
        text: 'Estoque Reserva',
        value: 'stockReserve',
        width: '8%',
        align: 'center',
      },
      { text: 'PDV WAP', value: 'productPrice', width: '8%', align: 'center' },
      {
        text: 'PDV Seller',
        value: 'sellerPrice',
        width: '8%',
        align: 'center',
      },
      { text: 'Ações', value: 'action', width: '10%', align: 'center' },
    ],
    reservationHeaders: [
      { text: 'ID', value: 'orderId' },
      { text: 'Status', value: 'orderSellerStatus' },
      { text: 'Quantidade', value: 'orderProductAmount' },
      { text: 'Ações', value: 'action' },
    ],
    search: '',
    importCsv: false,
    loading: false,
    productsWap: [],
    productWapSkuId: 0,
    productsWapNotBound: [],
    products: [],
    orders: [],
    product: {},
    rule: {
      cep: [
        (v) => !!v || 'CEP é obrigatório!',
        (v) => (v && v.length <= 9) || 'CEP não pode ter mais de 9 caracteres!',
        (v) => /\d{5}[-]\d{3}/.test(v) || 'Apenas letras minúsculas e "-" são permitidos no ID',
      ],
    },
    priceHistoryDialog: false,
    chart: {
      xAxis: {
        data: [],
      },
      tooltip: {
        trigger: 'item',
        formatter: function(params) {
          return `<b>${params.data.name}</b> <br /> Por ${params.data.idUser} em ${params.data.createdAt}`
        },
      },
      yAxis: {
        type: 'value',
      },
      series: [
        {
          type: 'line',
          data: [],
          markPoint: {
            data: [
              { type: 'max', name: 'Max' },
              { type: 'min', name: 'Min' },
            ],
          },
          markLine: {
            data: [{ type: 'average', name: 'Avg' }],
          },
        },
      ],
    },
    selected: [],
    massUpdate: false,
  }),
  methods: {
    getStatusSeller,
    save(product) {
      this.snack = true
      const data = {
        stockAmount: product.stockAmount,
        sellerProductId: product.sellerProductId,
        sellerId: product.sellerId,
        skuId: product.skuId,
      }
      const url = `${baseApiUrl}/stockSellerUpdate`
      axios
        .put(url, data)
        .then((res) => {
          this.snackColor = 'success'
          this.snackText = 'Dados Salvos'
          this.loadProducts()
        })
        .catch(showError)
      this.snackColor = 'success'
      this.snackText = 'Dados Salvos'
    },
    cancel() {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Operação Cancelada'
    },
    open() {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Caixa de diálogo aberta'
    },
    async openDetails(item) {
      await this.loadOrders(item)
      this.detailsDialog = true
    },
    loadContent(order) {
      let route = this.$router.resolve({
        name: 'Order',
        params: { id: order },
      })
      window.open(route.href, '_blank')
    },
    loadVtex(order) {
      window.open(` https://lojawap.myvtex.com/admin/checkout/#/orders/${order}`, '_blank')
    },
    loadProducts() {
      const id = this.$route.params.id
      this.loading = true
      const url = `${baseApiUrl}/seller/${id}/product`
      axios
        .get(url)
        .then((res) => {
          this.products = res.data
          this.loading = false
        })
        .catch(showError)
        .finally((this.loading = false))
    },
    loadProductsWap() {
      const id = this.$route.params.id
      this.loading = true
      const url = `${baseApiUrl}/product`
      axios
        .get(url)
        .then((res) => {
          this.loading = false
          this.productsWap = res.data
        })
        .catch(showError)
        .finally((this.loading = false))
    },
    loadProductsWapNotBound() {
      const id = this.$route.params.id
      this.loading = true
      const url = `${baseApiUrl}/seller/${id}/product/notbound`
      axios
        .get(url)
        .then((res) => {
          this.loading = false
          this.productsWapNotBound = res.data
        })
        .catch(showError)
        .finally((this.loading = false))
    },
    async loadOrders(item) {
      this.orders = []
      this.loading = true
      const sellerId = this.$route.params.id
      const url = `${baseApiUrl}/seller/${sellerId}/product/${item.skuId}/orders`
      await axios
        .get(url)
        .then((res) => {
          this.orders = res.data
          this.loading = false
        })
        .catch(showError)
      // .finally((this.loading = false))
    },
    importInput() {
      this.$refs.arquivo.click()
    },
    sendFile() {
      const id = this.$route.params.id
      const url = `${baseApiUrl}/seller/${id}/product/csv`
      const file = document.querySelector('#fileInput')
      const formData = new FormData()
      formData.append('fileCsv', file.files[0])
      this.loading = true

      axios
        .post(url, formData, {
          headers: {
            'Content-Type': `multipart/form-data;`,
          },
        })
        .then(() => {
          this.loadProducts()
        })
        .catch(showError)
        .finally(() => {
          document.querySelector('#fileInput').value = ''
          this.loading = false
        })
    },
    openAddProductDialog() {
      this.product = {}
      this.addProductDialog = true
      this.editProductFlag = false
    },
    openImportCsvDialog() {
      this.importCsv = true
    },
    saveProduct() {
      const id = this.$route.params.id
      this.loading = true
      const url = `${baseApiUrl}/seller/${id}/product`
      if (!this.editProductFlag) {
        axios
          .post(url, this.product)
          .then((res) => {
            this.addProduct = false
            this.addProductDialog = false
            this.loadProducts()
          })
          .catch(showError)
          .finally((this.loading = false))
      } else {
        axios
          .put(url, this.product)
          .then((res) => {
            this.addProduct = false
            this.addProductDialog = false
            this.loadProducts()
          })
          .catch(showError)
          .finally((this.loading = false))
      }
    },
    deleteProduct(item) {
      const id = this.$route.params.id
      const url = `${baseApiUrl}/seller/${id}/product`
      if (confirm('Tem certeza que deseja remover este produto?')) {
        axios
          .delete(url, { data: { id: item.sellerProductId } })
          .then(() => {
            this.loadProducts()
          })
          .catch(showError)
      }
    },
    editProduct(item) {
      this.product = item
      this.editProductFlag = true
      this.addProductDialog = true
    },
    sendCsvFile() {
      this.loading = true
      this.importCsv = false
      const id = this.$route.params.id
      const url = `${baseApiUrl}/seller/${id}/product/saveCsv`
      const file = document.querySelector('#file')
      var formData = new FormData()
      formData.append('fileCsv', file.files[0])
      axios
        .post(url, formData, {
          headers: {
            'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
          },
        })
        .then((res) => {
          this.loadProduct()
        })
    },
    stockStatus(stock) {
      if (stock.stockRequestDate == '' || stock.stockRequestDate == undefined) {
        return 'blue-grey darken-1'
      } else if (stock.stockRequestDate > stock.stockResponseDate || stock.stockResponseDate == undefined) {
        return 'primary'
      } else if (stock.stockRequestDate <= stock.stockResponseDate) {
        return 'green darken-4'
      } else {
        return 'red darken-4'
      }
    },
    boundProduct(product) {
      const id = this.$route.params.id
      const url = `${baseApiUrl}/match/${id}`
      this.product = product
      axios
        .put(url, this.product)
        .then((res) => {
          this.loadProducts()
          this.loadProductsWap()
        })
        .catch(showError)
    },
    searchSkuIdByEan(item) {
      const url = `${baseApiUrl}/product/ean/${item.sellerProductEan}`
      axios
        .get(url)
        .then((res) => {
          if (res.data.skuId) {
            item.skuId = res.data.skuId
            this.boundProduct(item)
          }
        })
        .catch(showError)
    },
    async update(sku) {
      let products = []
      if (!this.massUpdate) {
        products.push(sku)
      } else {
        products = this.selected
      }

      this.quantity = {
        total: products.length,
        actual: 0,
      }
      this.loading = true

      for (let i = 0; i < products.length; i++) {
        const element = products[i]
        const sellerProductId = element.sellerProductId
        const sellerId = element.sellerId

        const object = {
          listPrice: element.productPrice,
          discount: this.slider,
          price: this.appliedDiscount(element.productPrice),
        }
        const url = `${baseApiUrl}/seller/${sellerId}/sku/${sellerProductId}`
        await axios
          .patch(url, object)
          .then(() => {
            this.quantity.actual += 1
          })
          .catch(showError)
      }

      if (this.quantity.actual === this.quantity.total) {
        this.$toasted.global.defaultSuccess()
        this.massUpdate = false
        this.priceMarginDialog = false
        this.slider = 0.0
        this.min = 0.0
        this.max = 0.0
        this.$toasted.global.defaultSuccess()
        this.loadProducts()
      }
    },
    getPriceHistoryDialog(item) {
      this.loading = true
      this.object = item
      const sellerProductId = item.sellerProductId
      const sellerId = item.sellerId

      const url = `${baseApiUrl}/seller/${sellerId}/sku/${sellerProductId}/price`
      axios
        .get(url)
        .then((res) => {
          this.priceHistoryDialog = true
          this.loading = false
          this.chart.xAxis.data = []
          this.chart.series[0].data = []

          for (let i = 0; i < res.data.length; i++) {
            const element = res.data[i]
            this.chart.xAxis.data.push(this.$options.filters.formatDate(element.createdAt))
            this.chart.series[0].data.push({
              value: element.price / 100,
              name: this.$options.filters.formatMoney(element.price),
              createdAt: this.$options.filters.formatFullDate(element.createdAt),
              idUser: element.idUser,
            })
          }
        })
        .catch(showError)
        .finally(() => {
          this.loading = false
        })
    },
    editPriceMargin(item, mass = false) {
      if (item && !mass) {
        this.object = item
        if (item.minPriceRange) {
          this.min = item.minPriceRange > item.sellerMinPrice ? item.sellerMinPrice : item.minPriceRange
          this.min = parseFloat(this.min).toFixed(2)
        }
        if (item.maxPriceRange) {
          this.max = item.maxPriceRange > item.sellerMaxPrice ? item.sellerMaxPrice : item.maxPriceRange
          this.max = parseFloat(this.max).toFixed(2)
        }
        this.slider = this.object.discount | 0.0
      } else {
        this.massUpdate = mass
        this.min = 0.0
        this.max = 100.0
      }
      this.priceMarginDialog = true
    },
    closeMargin() {
      this.object = []
      this.slider = 0
      this.min = 0
      this.max = 0
    },
    appliedDiscount(rawPrice) {
      let discount = this.slider
      return rawPrice - rawPrice * ((discount * -1) / 100)
    },
    downloadCSV() {
      const data = this.products
      const fileName = 'download-seller-stock'
      const csv = this.convertArrayOfObjectsToCSV(data)
      const link = document.createElement('a')
      link.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
      link.download = fileName + '.csv'
      link.click()
    },
    convertArrayOfObjectsToCSV(data) {
      const columnDelimiter = ';'
      const lineDelimiter = '\n'
      const keys = Object.keys(data[0])

      let result = ''
      result += keys.join(columnDelimiter)
      result += lineDelimiter

      data.forEach((item) => {
        let ctr = 0
        keys.forEach((key) => {
          if (ctr > 0) result += columnDelimiter
          result += item[key] ?? ''
          ctr++
        })
        result += lineDelimiter
      })

      return result
    },
  },
  async mounted() {
    await Promise.all([this.loadProducts(), this.loadProductsWap(), this.loadProductsWapNotBound()])
  },
}
</script>

<style scoped>
.space {
  margin: 10px;
}
</style>
